const addRedirect = (url, redirectUrl, forceRedirect) => {
  const force = forceRedirect ? "force_return=true&" : "";
  const separator = url.indexOf("?") > -1 ? "&" : "?";
  return `${url}${separator}${force}url=${redirectUrl}`;
};

const getLoginURL = (event, config, target, redirectId) => {
  let actualTarget = target;
  if (redirectId && actualTarget) {
    return `${config.login_url}?${actualTarget}&r_id=${redirectId}`;
  }
  if (!actualTarget) {
    actualTarget = document.location.href;
  } else if (event && event.actualTarget.getElementsByTagName("a")[0]) {
    const href = event.actualTarget.getElementsByTagName("a")[0].getAttribute("href");
    if (href.indexOf("http:") === 0) {
      actualTarget = href;
    } else {
      actualTarget = `${document.location.protocol}://${document.location.host}${href}`;
    }
  }
  if (actualTarget) {
    actualTarget = encodeURIComponent(actualTarget);
    return addRedirect(config.login_url, actualTarget, true);
  }
  return "";
};

const redirectToLogin = (event, config, target, redirectId) => {
  const url = getLoginURL(event, config, target, redirectId);
  if (url) document.location = url;
  return true;
};

function isTouchDevice() {
  if ("ontouchstart" in window) return true;

  // eslint-disable-next-line no-undef
  if (window.DocumentTouch && document instanceof DocumentTouch) return true;

  return window.matchMedia("(pointer: coarse)").matches;
}

function mergeArrays(response1, response2, field) {
  let mergedArray = [];
  if (response1) mergedArray = [...response1, ...response2];
  else mergedArray = [...response2];
  return Array.from(new Set(mergedArray.map(el => el[field]))).map(el => {
    return mergedArray.find(item => item[field] === el);
  });
}

function sortArrayByChannel(results, reference) {
  if (!reference || !reference.length) return results;
  return results.sort((a, b) => reference.indexOf(a.channel) - reference.indexOf(b.channel));
}

function getResourceMetaDataValue(resource, key) {
  const metaData = resource.meta_data ? resource.meta_data.filter(md => md.code === key) : [];
  return metaData.length ? metaData[0].value : "";
}

export default {
  redirectToLogin,
  addRedirect,
  getLoginURL,
  isTouchDevice,
  mergeArrays,
  sortArrayByChannel,
  getResourceMetaDataValue,
};
